import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Instagram, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { to: "/", label: "INÍCIO", end: true },
  { to: "/proximo-encontro", label: "PRÓXIMO ENCONTRO" },
  { to: "/memorias", label: "MEMÓRIAS" },
  { to: "/palavra", label: "PALAVRA" },
  { to: "/sobre", label: "SOBRE" },
  { to: "/contato", label: "CONTATO" },
];

export default function Header({ settings }) {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  useEffect(() => { document.body.style.overflow = open ? "hidden" : ""; }, [open]);

  return (
    <>
      <header className="sticky top-0 z-50 bg-[#000000]/90 backdrop-blur-2xl border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-3">
          <NavLink to="/" data-testid="header-logo-link"><Logo size="md" /></NavLink>

          <nav className="hidden lg:flex items-center gap-6">
            {links.map((l) => (
              <NavLink
                key={l.to} to={l.to} end={l.end}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `text-xs font-bold tracking-[0.18em] transition-colors ${isActive ? "text-blue-400" : "text-slate-300 hover:text-white"}`
                }
              >{l.label}</NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <button
              data-testid="header-rsvp-btn"
              onClick={() => nav("/confirmar-presenca")}
              className="btn-primary text-sm px-4 py-2.5"
            >CONFIRMAR PRESENÇA</button>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 text-white"
            onClick={() => setOpen((o) => !o)}
          >{open ? <X size={24} /> : <Menu size={24} />}</button>
        </div>
      </header>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden fixed inset-0 top-[68px] z-40 bg-[#000000]/95 backdrop-blur-2xl p-6 flex flex-col gap-6 animate-fade-up overflow-y-auto">
          {links.map((l) => (
            <NavLink
              key={l.to} to={l.to} end={l.end}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-2xl font-display font-black tracking-tight ${isActive ? "text-blue-400" : "text-white"}`
              }
            >{l.label}</NavLink>
          ))}
          <button
            data-testid="mobile-rsvp-btn"
            onClick={() => { setOpen(false); nav("/confirmar-presenca"); }}
            className="btn-primary w-full mt-4"
          >CONFIRMAR PRESENÇA</button>
          {settings?.instagram_url && (
            <a href={settings.instagram_url} target="_blank" rel="noreferrer" className="btn-ghost w-full"><Instagram size={18} /> {settings?.instagram_handle || "Instagram"}</a>
          )}
          {settings?.whatsapp_number && (
            <a href={`https://wa.me/${settings.whatsapp_number.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="btn-ghost w-full"><MessageCircle size={18} /> Falar com a equipe</a>
          )}
        </div>
      )}
    </>
  );
}
